import React, { useState, useEffect, useRef } from 'react';

import Notifications from './Notifications';
import Messagerie from './Messagerie';

const RightSidebar = ({ isOpen, setIsOpen, notifications, defaultTab = 'notif' }) => {

    const panelRef = useRef(null);

    const [selectedTab, setSelectedTab] = useState(defaultTab);

    useEffect(() => {
        if (isOpen) {
            setSelectedTab(defaultTab);
        }
    }, [isOpen, defaultTab]);

    const [shouldRender, setShouldRender] = useState(false);
    const [isVisible, setIsVisible] = useState(false);

    const toggleRightSidebar = () => {
        if (isOpen) {
            setIsOpen(false);
        } else {
            setShouldRender(true);
            setIsOpen(true);
        }
    };

    useEffect(() => {
        if (isOpen) {
            setShouldRender(true);
        } else {
            setIsVisible(false);
            const timer = setTimeout(() => setShouldRender(false), 300);
            return () => clearTimeout(timer);
        }
    }, [isOpen]);

    useEffect(() => {
        if (shouldRender) {
            requestAnimationFrame(() => {
                setIsVisible(true);
            });
        }
    }, [shouldRender]);

    useEffect(() => {
        function handleClickOutside(event) {
            if (panelRef.current && !panelRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        }

        if (isOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isOpen, setIsOpen]);

    if (!shouldRender) return null;

    return (
        <>
            <div className="top-0 z-50 fixed w-full h-full overflow-x-hidden overflow-y-auto">
                <div
                    className={`
                        w-full absolute z-5 right-0 h-full transform transition-transform duration-500 ease-in-out
                        ${isVisible ? 'translate-x-0' : 'translate-x-full'}
                    `}
                >
                    <div ref={panelRef} className="right-0 absolute flex flex-col bg-gray-900 p-8 w-full md:w-[600px] h-screen">
                        <div className="flex justify-between items-center mb-10 pt-2 pb-4 border-gray-300 border-b">
                            <div className="relative flex flex-1 gap-4">
                                {['notif', 'mess'].map((tab, index) => (
                                    <div key={tab} className="relative flex flex-col items-center">
                                        <button
                                            onClick={() => setSelectedTab(tab)}
                                            className={`w-10 h-10 rounded-full flex items-center justify-center transition-all duration-500 ease-in-out 
                                            ${selectedTab === tab ? '-translate-y-1' : 'opacity-80 hover:opacity-100'}
                                            `}
                                            style={{
                                                background: index === 0
                                                    ? 'linear-gradient(270deg, #f9c829, #ffd071, #f9c829,#ffcb3b, #F9B429)'
                                                    : 'linear-gradient(270deg, #22c55e, #4ade80, #16a34a, #22c55e, #16a34a)',
                                                backgroundSize: '600% 600%',
                                                animation: 'gradientWave 8s ease infinite',
                                                boxShadow: index === 0
                                                    ? '0 0 10px 2px rgba(249, 193, 41, 0.6)'
                                                    : '0 0 8px 2px rgba(117, 249, 41, 0.6)'
                                            }}
                                        >
                                            {index === 0 ? (
                                                <i className="text-white fa-solid fa-bell" />
                                            ) : (
                                                <i className="text-white fa-solid fa-comment" />
                                            )}
                                        </button>

                                        {/* {selectedTab === tab && (
                                            <div className="border-t-8 border-t-orange-500 border-r-8 border-r-transparent border-l-8 border-l-transparent w-0 h-0 transition-all duration-300"></div>
                                        )} */}
                                    </div>
                                ))}
                            </div>

                            <button
                                aria-label="close modal"
                                onClick={toggleRightSidebar}
                            >
                                <svg
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M18 6L6 18"
                                        stroke="#ffffff"
                                        strokeWidth="1.25"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M6 6L18 18"
                                        stroke="#ffffff"
                                        strokeWidth="1.25"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>

                            </button>
                        </div>

                        <div className="relative flex-1 w-full overflow-hidden">
                            <div
                                className="flex w-[100%] h-full transition-transform duration-500 ease-in-out"
                                style={{
                                    transform:
                                        selectedTab === 'notif'
                                            ? 'translateX(0%)'
                                            : selectedTab === 'mess'
                                                ? 'translateX(-100%)'
                                                : 'translateX(-200%)',
                                }}
                            >
                                {/*1*/}
                                <div className="flex-shrink-0 w-full">
                                    <Notifications
                                        notifications={notifications}
                                        refreshUserNotifications={() => {}}
                                    />
                                </div>

                                {/*2*/}
                                <div className="flex flex-col flex-shrink-0 w-full">
                                    <Messagerie
                                        messages={[]}
                                        refreshMessages={() => {}}
                                    />
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    );
};

export default RightSidebar;
